import { createApp } from "vue";
// import vLoading from "./directives/loading";
import {
  ElAvatar,
  ElButton,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCascader,
  ElCheckbox,
  ElCol,
  ElContainer,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElEmpty,
  ElFooter,
  ElForm,
  ElFormItem,
  ElImage,
  ElInput,
  ElLoading,
  ElMain,
  ElMessage,
  ElOption,
  ElProgress,
  ElRadioButton,
  ElRadioGroup,
  ElRow,
  ElSelect,
  ElSkeleton,
  ElSkeletonItem,
  ElTag,
  ElText,
} from "element-plus";
import "element-plus/es/components/avatar/style/css";
import "element-plus/es/components/button/style/css";
import "element-plus/es/components/card/style/css";
import "element-plus/es/components/carousel/style/css";
import "element-plus/es/components/carousel-item/style/css";
import "element-plus/es/components/cascader/style/css";
import "element-plus/es/components/checkbox/style/css";
import "element-plus/es/components/col/style/css";
import "element-plus/es/components/container/style/css";
import "element-plus/es/components/descriptions/style/css";
import "element-plus/es/components/descriptions-item/style/css";
import "element-plus/es/components/dialog/style/css";
import "element-plus/es/components/empty/style/css";
import "element-plus/es/components/footer/style/css";
import "element-plus/es/components/form/style/css";
import "element-plus/es/components/form-item/style/css";
import "element-plus/es/components/image/style/css";
import "element-plus/es/components/input/style/css";
import "element-plus/es/components/main/style/css";
import "element-plus/es/components/option/style/css";
import "element-plus/es/components/progress/style/css";
import "element-plus/es/components/radio-button/style/css";
import "element-plus/es/components/radio-group/style/css";
import "element-plus/es/components/row/style/css";
import "element-plus/es/components/select/style/css";
import "element-plus/es/components/skeleton/style/css";
import "element-plus/es/components/skeleton-item/style/css";
import "element-plus/es/components/tag/style/css";
import "element-plus/es/components/text/style/css";
import "element-plus/es/components/loading/style/css";
import "element-plus/es/components/message/style/css";
import "@/styles/reset.css";
import App from "./App.vue";
import router from "@/router";
import axios from "axios";
import "@/api/wxFont.js";
import eventBus from "./eventBus.js";
import store from "./store";
store.dispatch("setting/fetchSetting");
import { titleController, isWeChat } from "@/utils";

//测试api接口
// import * as activeApi from "@/api/active";

const app = createApp(App);

// app.directive("loading", vLoading);

app.config.globalProperties.$bus = eventBus;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
app.config.globalProperties.$isWeChat = isWeChat();

app.use(router);

[
  ElAvatar,
  ElButton,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCascader,
  ElCheckbox,
  ElCol,
  ElContainer,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElEmpty,
  ElFooter,
  ElForm,
  ElFormItem,
  ElImage,
  ElInput,
  ElMain,
  ElOption,
  ElProgress,
  ElRadioButton,
  ElRadioGroup,
  ElRow,
  ElSelect,
  ElSkeleton,
  ElSkeletonItem,
  ElTag,
  ElText,
].forEach((component) => app.component(component.name, component));
app.use(ElLoading);
app.config.globalProperties.$message = ElMessage;

router.afterEach(to => {
  if (to.meta.title) {
    titleController.setRouteTitle(to.meta.title);
  }
})

app.mount("#app");
